const users = [
  {
    id: 1,
    imgUrl: "/images/user1.png",
    brabbler: "24.5k",
  },
  {
    id: 2,
    imgUrl: "/images/user2.png",
    brabbler: "24.5k",
  },
  {
    id: 3,
    imgUrl: "/images/user3.png",
    brabbler: "24.5k",
  },
  {
    id: 4,
    imgUrl: "/images/user3.png",
    brabbler: "24.5k",
  },
  {
    id: 5,
    imgUrl: "/images/user3.png",
    brabbler: "24.5k",
  },
];

export function getUsers() {
  return users;
}
